


export const injectCustomClasses = (classes) => {

    const stripStringsFromArray = () => {
        return classes.reduce((stringOClasses, currentClass) => {
            return stringOClasses + " " + currentClass
        }, '')
    }
    if (classes) {
        let classesString = classes.constructor === Array ? stripStringsFromArray() : classes;
        if (classesString.length > 0) {
            return classesString;
        }
    }
    return null;
}